// extracted by mini-css-extract-plugin
export default {"show-slide":"ShowSlide_show-slide__V1hWM"};